module.exports = __webpack_public_path__ + "static/media/Picton2.80df269a.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/Picton2.png
// module id = 346
// module chunks = 0